import { useProfile } from "../context/ProfileContext";
import { ArrowUpRight, PlayCircle } from "lucide-react";

export default function FilmLinks() {
  const PROFILE = useProfile();
  return (
    <section
      id="film"
      className="relative bg-[#0A0A0A] py-24 sm:py-32 border-t border-white/10"
      data-testid="film-section"
    >
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-4">
              05 — Film & Profiles
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase font-bold tracking-tight text-white leading-none">
              <PlayCircle
                size={48}
                className="inline-block mb-2 mr-3 text-[#E60000]"
                strokeWidth={1.5}
              />
              Watch the Tape
            </h2>
          </div>
          <p className="max-w-md text-[#8A8A8A] text-base leading-relaxed">
            Recruiting-ready film, current stats, and verified profiles across every major college coach platform.
          </p>
        </div>

        <div className="border-t border-white/10" data-testid="film-links">
          {PROFILE.profiles.map((p, i) => (
            <a
              key={p.url}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between gap-6 py-6 lg:py-8 px-2 lg:px-4 border-b border-white/10 hover:bg-[#E60000] transition-colors"
              data-testid={`film-link-${i}`}
            >
              <div className="flex items-center gap-6 min-w-0">
                <span className="font-display text-sm tracking-[0.3em] uppercase text-[#8A8A8A] group-hover:text-white w-10 shrink-0">
                  0{i + 1}
                </span>
                <span className="font-display text-2xl sm:text-3xl lg:text-4xl uppercase font-bold tracking-tight text-white group-hover:text-white truncate">
                  {p.label}
                </span>
              </div>
              <ArrowUpRight
                className="text-[#8A8A8A] group-hover:text-white shrink-0 transition-transform group-hover:rotate-45"
                size={28}
                strokeWidth={2}
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
